/* eslint-disable no-new */
import Vue from 'vue';
import Buefy from 'buefy';
import Vuelidate from 'vuelidate';
import App from './App';
import router from './router';
import CmsUtils from './cms-utils';
import TsstAdminUtils from './tsst-admin-utils';
import CmsConsts from './cms-utils/consts';
import store from './store';
import getEnv from './utils/env';

Vue.use(Buefy);
Vue.use(Vuelidate);

Vue.config.productionTip = false;

store.dispatch('tryAutoSignIn');

Vue.prototype.$cmsUtils = new CmsUtils();
Vue.prototype.$cmsConsts = new CmsConsts();
Vue.prototype.$tsstAdminUtils = new TsstAdminUtils();
Vue.prototype.$getEnv = getEnv;

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
});
